module.exports = __webpack_public_path__ + "media/images/cowork-preview-678c61f5123f6e3e059ab4f927b4c6dd.jpg";